import { FC, useState } from "react";
import { AccordionProps } from "./types";
import classNames from "classnames";
import styles from "./Accordion.module.css";

const Accordion: FC<AccordionProps> = ({
  isDisabled,
  defaultIsOpen,
  htmlId,
  header,
  subHeader,
  content,
  classNameContainer,
  classNameHeader,
  classNameContent,
  classNameSubHeader
}) => {
  const [isOpen, setIsOpen] = useState(Boolean(defaultIsOpen));

  const handleSetIsOpen = () => {
    if (!isDisabled) {
      setIsOpen(!isOpen);
    }
  }

  return (
    <article
      id={htmlId}
      className={classNames(styles["accordion"], classNameContainer)}
    >
      <header className={classNames(styles["accordion__header"], classNameHeader)}>
        {header(isOpen, handleSetIsOpen)}
        <div className={classNames(styles["accordion__subheader"], classNameSubHeader)}>
          {subHeader && subHeader(isOpen)}
        </div>
      </header>
      {isOpen && (
        <section className={classNames(styles["accordion__content"], classNameContent)}>
          {content(isOpen)}
        </section>
      )}
    </article>
  );
};

export default Accordion;
